import './styles.scss';

import * as React from 'react';
import classnames from 'classnames';

const styles = require('../venue-cta/venue-primary-cta/VenuePrimaryCTA.scss');

import { toUSD } from '@weddingspot/ws-core-components';

export interface StickySpotEstimateProps {
    venueId: number;
    isPriced: boolean;
    isRdvProfile: boolean;
    startingPricePerPersonRDs?: number;
    budgetRangeMin?: number;
    budgetRangeCapacity?: number;
    estimateTotal?: number;
    onClickContact?: () => void;
    onClickQuote?: () => void;
}

export default class StickySpotEstimate extends React.Component<StickySpotEstimateProps> {
    renderText() {
        const props = this.props;

        // Show price per person for RD venue
        if (this.props.isRdvProfile) {
            if (!!this.props.startingPricePerPersonRDs) {
                return <div className='StickySpotEstimate--text'>Starting at {toUSD(this.props.startingPricePerPersonRDs)} per person</div>;
            } else {
                return;
            }
        }

        // Show spot estimate if they user has one
        if (!!props.estimateTotal) {
            return (
                <div className='StickySpotEstimate--text'>
                    Your Spot Estimate:
                    <span className='VenuePage--primary-cta-estimate'>{`${toUSD(props.estimateTotal)}`}</span>
                </div>
            );
        }

        // Show budget range if venue is priced
        if (props.isPriced && !!props.budgetRangeMin && !!props.budgetRangeCapacity) {
            return (
                <div className='StickySpotEstimate--text StickySpotEstimate--text-no-strings'>
                    Get a personalized estimate now — no strings attached.
                </div>
            );
        }

        return;
    }

    renderPrimaryCTAButton() {
        const props = this.props;
        const defaultCtaClassNames = 'StickySpotEstimate--button nx-button nx-button--primary';
        const ctaButtonClass = 'StickySpotEstimate--button-profile-cta';
        if (this.props.isRdvProfile) {
            return (
                <button className={classnames(defaultCtaClassNames)} onClick={props.onClickQuote}>
                    REQUEST A QUOTE
                </button>
            );
        }

        if (!!props.estimateTotal) {
            return (
                <button className={classnames(defaultCtaClassNames)} onClick={props.onClickContact}>
                    CONTACT VENUE
                </button>
            );
        }

        if (props.isPriced) {
            return (
                <a className={classnames(defaultCtaClassNames, ctaButtonClass)} href={`/pricing/${props.venueId}/estimate/`} rel='nofollow'>
                    PRICE VENUE
                </a>
            );
        } else {
            return (
                <button className={classnames('StickySpotEstimate--button  nx-button nx-button--primary')} onClick={props.onClickQuote}>
                    REQUEST A QUOTE
                </button>
            );
        }
    }

    renderContactVenueCta() {
        return (
            <button
                className={classnames('StickySpotEstimate--button StickySpotEstimate--button-contact-venue nx-button')}
                onClick={this.props.onClickContact}
            >
                CONTACT VENUE
            </button>
        );
    }

    renderVenueProfileCta() {
        if (!this.props.estimateTotal) {
            return (
                <div className={classnames('StickySpotEstimate--button-group')}>
                    {this.renderPrimaryCTAButton()}
                    {this.renderContactVenueCta()}
                </div>
            );
        }
        return (
            <div className={classnames('StickySpotEstimate--button-group')}>
                {this.renderText()}
                {this.renderPrimaryCTAButton()}
            </div>
        );
    }

    render() {
        const showBudget =
            (this.props.isPriced && !this.props.estimateTotal && !!this.props.budgetRangeMin && !!this.props.budgetRangeCapacity) ||
            (this.props.isRdvProfile && !!this.props.startingPricePerPersonRDs);

        return (
            <div className={classnames('StickySpotEstimate', { StickySpotEstimate__budget: showBudget })}>
                {this.renderVenueProfileCta()}
            </div>
        );
    }
}
